import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentMint = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ALL_Document_Mint 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M46.56 59.52H15.35C13.94 59.52 12.8 58.38 12.8 56.97V7.13C12.8 5.72 13.94 4.58 15.35 4.58H32.88C34.26 4.58 35.38 5.7 35.38 7.08V15.11C35.38 16.7 36.67 17.99 38.26 17.99H46.62C48 17.99 49.12 19.11 49.12 20.49V56.98C49.12 58.39 47.98 59.53 46.57 59.53L46.56 59.52Z",
				fill: "#D0F5DA"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M51.82 15.17V57.46C51.82 60.07 49.7 62.18 47.1 62.18H14.82C12.21 62.18 10.1 60.06 10.1 57.46V6.64C10.1 4.03 12.22 1.92 14.82 1.92H38.55C40.1 1.92 41.58 2.56 42.65 3.69L50.62 12.14C51.4 12.96 51.83 14.05 51.83 15.19L51.82 15.17Z",
				stroke: "#311123",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M17.57 15.75H31.38",
				stroke: "#311123",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M17.57 26.55H44.35",
				stroke: "#311123",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M17.57 37.35H44.35",
				stroke: "#311123",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M17.57 48.15H44.35",
				stroke: "#311123",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_7",
				d: "M38.56 12.96L38.54 1.94C40.09 1.94 41.57 2.58 42.64 3.71L50.61 12.16C51.39 12.98 51.82 14.07 51.82 15.21H38.54L38.56 12.97V12.96Z",
				stroke: "#311123",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgDocumentMint;
